import React from 'react';

export const bgImageStyle = ({ src, aspectRatio, fit = 'cover', extra = {} }) => ({
  aspectRatio,
  width: '100%',
  overflow: 'hidden',
  backgroundColor: '#C0C0C0',
  backgroundImage: src ? `url("${src}")` : undefined,
  backgroundSize: fit,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  ...extra,
});

const BgImage = ({ src, aspectRatio, fit = 'cover', className = '', alt = '', style = {}, ...props }) => (
  <div
    role={alt ? 'img' : undefined}
    aria-label={alt || undefined}
    className={['noselect', className].filter(Boolean).join(' ')}
    style={bgImageStyle({ src, aspectRatio, fit, extra: style })}
    fetchpriority={'high'}
    {...props}
  />
);

export default BgImage;
